// 可折叠文本模块
  (function () {
    function initFoldedText(section) {
      const wrappers = section.querySelectorAll('.newFoldedText');

      wrappers.forEach(wrapper => {
        const items = wrapper.querySelectorAll('.newBotTextBox');

        items.forEach(item => {
          const icon = item.querySelector('.newTextBotIcon');
          const content = item.nextElementSibling;

          if (
            !icon ||
            !content ||
            !content.classList.contains('newTextBotText')
          ) return;

          // 防止重复绑定
          if (icon.dataset.binded) return;
          icon.dataset.binded = 'true';

          icon.addEventListener('click', function () {
            item.classList.toggle('active');

            const isOpen = item.classList.contains('active');

            // 获取 richtext 所有直接内容
            const children = content.children;

            Array.from(children).forEach(el => {
              el.style.display = isOpen ? 'block' : 'none';
            });
          });
        });
      });
    }

    // 首次加载
    document.addEventListener('DOMContentLoaded', function () {
      document
        .querySelectorAll('.shopify-section')
        .forEach(section => initFoldedText(section));
    });

    // Shopify 编辑器动态刷新
    document.addEventListener('shopify:section:load', function (e) {
      initFoldedText(e.target);
    });
  })();
//  ------------------------